module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./fa.coffee"));
	}, "fa");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=[name]!./app/locale/fa.coffee
// module id = 203
// module chunks = 100